import { useMutation } from '@apollo/client/react'
import { Card, Col, Row } from 'antd'
import {
  type DocumentFragment,
  UpdateDocumentTagsDocument,
} from '~app/graph/generated/graphql'
import { Tag } from './Tag'
import useGetDocumentTags from './useGetDocumentTags'

/**
 * Component
 */

const styles: InlineStyles = {
  infoCardStyle: {
    marginBottom: 10,
  },
  cardHeadStyle: {
    display: 'none',
  },
}

interface Props {
  document: DocumentFragment
}

const TagSelector = ({ document }: Props) => {
  const [updateTags] = useMutation(UpdateDocumentTagsDocument)
  const tags = document.tags || []
  const saveTagValue = (tag: string) => {
    const { id } = document
    if (!tags.includes(tag)) {
      updateTags({ variables: { id, tags: [...tags, tag] } })
    } else {
      updateTags({
        variables: {
          id: document.id,
          tags: [...tags].filter(item => item !== tag),
        },
      })
    }
  }
  const { documentTypeTags, senderTypeTags } = useGetDocumentTags()
  return (
    <Card style={styles.infoCardStyle} headStyle={styles.cardHeadStyle}>
      <Row>
        <Col span={12}>
          {documentTypeTags.map(tag => (
            <Tag
              key={tag}
              tag={tag}
              onSaveTag={saveTagValue}
              isAssigned={tags.includes(tag)}
            />
          ))}
        </Col>
        <Col span={12}>
          {senderTypeTags.map(tag => (
            <Tag
              key={tag}
              tag={tag}
              onSaveTag={saveTagValue}
              isAssigned={tags.includes(tag)}
            />
          ))}
        </Col>
      </Row>
    </Card>
  )
}

export default TagSelector
